import React from "react";
import siteConfig from "../config/siteConfig";
import PolicyPage from "./PolicyPage";

function Cookies() {
  const sections = [
    {
      id: "about",
      title: "About browser storage",
      paragraphs: [
        "Cookies are small text files a website can place on a device. Browser local storage is a related technology that lets a site remember information in the browser without sending it with every request. This policy explains the current use of those technologies by this storefront.",
      ],
    },
    {
      id: "current-use",
      title: "What this store uses",
      paragraphs: [
        `The current ${siteConfig.brandName} storefront uses local storage for the shopping functions you request. It does not intentionally set optional analytics, personalisation or advertising cookies. Hosting and payment providers may process basic request or security information under their own notices when their services are used.`,
      ],
      items: [
        "cartItems — stores the product, quantity and selected options in your shopping bag until you remove them or clear site data.",
        "wishlistItems — stores the identifiers of products saved to your wishlist until you remove them or clear site data.",
      ],
    },
    {
      id: "essential",
      title: "Why it is used",
      paragraphs: [
        "This local storage is necessary to keep the bag and wishlist available between pages and browser visits. It is not used to follow you across unrelated websites, create an advertising profile or sell information about your browsing activity.",
      ],
    },
    {
      id: "payment-services",
      title: "Payment and external services",
      paragraphs: [
        "When you continue to the secure page of a payment provider, that provider may use cookies or similar technologies for authentication, fraud prevention and transaction processing. Those technologies are controlled by the provider and described in the notice shown on its service.",
      ],
    },
    {
      id: "controls",
      title: "Your controls",
      paragraphs: [
        "You can delete local storage and cookies through your browser's privacy or site-data settings. You may also configure the browser to block storage. Blocking or clearing the two store entries will remove the saved bag and wishlist and may prevent those features from persisting between visits.",
        "Because the current storefront does not intentionally use optional cookies, it does not display a separate optional-cookie consent panel. If optional analytics, advertising or personalisation tools are introduced, we will update this policy and provide any consent choices required by law before they are activated.",
      ],
    },
    {
      id: "changes-contact",
      title: "Changes and questions",
      paragraphs: [
        `The review date above identifies the current version. Questions about cookies, local storage or a future change may be sent to ${siteConfig.contact.email}.`,
      ],
    },
  ];

  return (
    <div className="policy policy--cookies">
      <PolicyPage
        eyebrow="Legal"
        title="Cookie policy"
        intro={`How ${siteConfig.brandName} uses browser storage and similar technologies.`}
        sections={sections}
        relatedLinks={[
          { label: "Privacy policy", to: "/privacy" },
          { label: "Security and fraud", to: "/security" },
          { label: "All policies", to: "/policies" },
          { label: "Contact", to: "/contact" },
        ]}
      />
    </div>
  );
}

export default Cookies;
